<section class="scan-select-container">
  <header class="header">
    <div role="button" class="close-btn-container">
      <img mat-dialog-close src="/assets/images/scan/close_icon.svg" alt="" />
    </div>
    <div class="header__title">Shipping label #{{ orders[0].shippingId }} is not unique.</div>
  </header>
  <div class="scan-select-form-container">
    <form [formGroup]="selectForm" (ngSubmit)="onSubmit()" class="scan-select-form" autocomplete="off">
      <div class="scan-select-form__title">Please Choose the correct shipping label:</div>
      <div class="scan-select-form__field">
        <mat-form-field
          appearance="outline"
          [ngClass]="{ 'scan-select-opened': orderSelect.panelOpen }"
          class="scan-select-field">
          <mat-label class="">Choosing shipping label</mat-label>
          <mat-select
            #orderSelect
            name="orderId"
            [disableOptionCentering]="true"
            formControlName="orderId"
            panelClass="scan-select-panel">
            @for (order of orders; track order) {
              <mat-option [value]="order.id">
                {{ order.shippingId + ' ' }}
                @if (order.orderBatch) {
                  {{ order.orderBatch.name + '-' }}
                }
                {{ order.createdDate | date: 'MMMM d, y' }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="scan-select-actions" mat-dialog-actions>
        <button
          mat-button
          mat-flat-button
          color="primary"
          class="scan-select-actions__submit"
          [disabled]="(selectForm.invalid && !selectedOrder) || loading">
          @if (!loading) {
            CONTINUE
          }
          @if (loading) {
            <mat-spinner [diameter]="20" class="scan-select-spinner"></mat-spinner>
          }
        </button>
      </div>
    </form>
  </div>
</section>
